import { coreInstance, mainInstance } from "api";
import Logo from "assets/images/takhtelogo.png";
import Axios from "axios";
import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Box } from "styled-components/box";
import { CookieUtils } from "utils";
import "./LoginPage.scss";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LoginPage = () => {
  let query = useQuery();
  let history = useHistory();
  const { serviceType } = useParams();

  useEffect(() => {
    const serviceTypeQuery = query.get("serviceType");
    const accessToken = query.get("t");
    const semesterID = query.get("sei");
    const schoolID = query.get("sci");
    const schoolName = query.get("schoolName");
    const endPointID = query.get("ei");
    const teacherID = query.get("ti");
    if (accessToken) {
      Axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
      coreInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;
      mainInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;
      CookieUtils.setCookie("endpointID", endPointID);
      CookieUtils.setCookie("token", accessToken);
      CookieUtils.setCookie("semesterID", semesterID);
      CookieUtils.setCookie("schoolID", schoolID);
      CookieUtils.setCookie("schoolName", schoolName);
      CookieUtils.setCookie("teacherID", teacherID);

      if (serviceType === "assignment" || serviceTypeQuery === "assignment") {
        history.replace("/assignments");
      } else if (
        serviceType === "sync-konj" ||
        serviceTypeQuery === "sync-konj"
      ) {
        history.replace("/sync-konj");
      } else {
        history.replace("/exams");
      }
    } else {
      // window.location.href = process.env.REACT_APP_SSO_LOGIN;
    }
  }, [history, query, serviceType]);

  return (
    <Box className="mx-auto login cu-center" width="300px">
      <Box width="85px" className="mx-auto">
        <img src={Logo} alt="دایاموز" title="دایاموز" />
      </Box>
      <Form>
        <Form.Group>
          <Form.Label>نام کاربری</Form.Label>
          <Form.Control type="text" placeholder="نام کاربری خود را وارد کنید" />
        </Form.Group>

        <Form.Group>
          <Form.Label>رمز عبور</Form.Label>
          <Form.Control
            type="password"
            placeholder="رمز عبور خود را وارد کنید"
          />
        </Form.Group>
        <Button variant="primary" type="submit" block>
          ورود
        </Button>
      </Form>
    </Box>
  );
};
export default LoginPage;
